<template>

  <div class="height-100">
    <creating
      v-if="creating"
      height="100%" />
    <div
      v-if="!creating"
      class="vflex">
      <div class="vflex-row-0 p-3">
        <BillingPlansTypes
          class="mb-3"
          v-model="cycleType" />
      </div>
      <div
        class="vflex-row-1"
        style="overflow: auto;">
          <div>
            <table
              class="table"
              v-if="planscopes.length"
              :class="{'box-loading': loading}"
              style="width: auto;">
              <tbody>
                <tr>
                  <td width="270" style="border: 0;"></td>
                  <td
                    style="border: 0;"
                    width="280"
                    v-for="(item, index) in planscopes"
                    :key="index">
                    <BillingPlansBox
                      :planscope="item"
                      :cycle-type="cycleType" />
                  </td>
                </tr>
                <tr>
                  <td><h5>Jobslot</h5> Quantidade de vagas abertas simultaneamente.</td>
                  <td
                    v-for="(item, index) in planscopes"
                    :key="index">
                    <span style="font-size: 1.4rem;">{{ item.limit_job_slot ? item.limit_job_slot : 'Ilimitado' }}</span>
                    <p v-if="!item.limit_job_slot">A cada 12 meses, avaliamos o volume médio mensal de vagas e o porte da empresa. Se houver aumento significativo, o valor pode ser reajustado, sempre com transparência e comunicação antecipada.</p>
                  </td>
                </tr>
                <tr>
                  <td><h5>Vídeo apresentação</h5>Vídeos de apresentação dos candidatos de forma prática e organizada.</td>
                  <td
                    v-for="(item, index) in planscopes"
                    :key="index"
                    style="font-size: 1.4rem;">
                    {{ item.limit_intervideos }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Parses</h5> Extração automático de dados dos currículos para economizar tempo.</td>
                  <td
                    v-for="(item, index) in planscopes"
                    :key="index"
                    style="font-size: 1.4rem;">
                    {{ item.limit_parses }}
                  </td>
                </tr>
                <tr>
                  <td><h5>Usuários</h5>Permite adicionar quantos usuários forem necessários.</td>
                  <td
                    v-for="(item, index) in planscopes"
                    :key="index"
                    style="font-size: 1.4rem;">
                    Ilimitado
                  </td>
                </tr>
                <tr
                  v-for="featureName in featuresNames"
                  :key="featureName">
                  <td><h5>{{ featureName.name }}</h5>{{ featureName.description }}</td>
                  <td
                    v-for="(item, index) in planscopes"
                    :key="index"
                    style="font-size: 1.4rem;">
                    <i v-if="!featureName.feature || item.features.includes(featureName.feature)" class="fas fa-check" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="!planscopes.length"
            class="mt-3 mb-3">  
            Nenhum plano encontrado.
          </div>
      </div>
    </div>
  </div>

</template>

<script>
import BillingPlansTypes from './BillingPlansTypes'
import BillingPlansBox from './BillingPlansBox'

export default {
  name: 'BillingPlans',
  components: {
    BillingPlansTypes,
    BillingPlansBox
  },
  props: {
    planscope: {
      type: [Object, null],
      default: null
    }
  },
  data () {
    return {
      creating: true,
      loading: true,
      cycleType: 'annually', // 'monthly'
      planscopes: [],
      featuresNames: [
        {name: 'Pipelines de candidatos', description: 'Organização visual e eficiente para gerenciar o processo seletivo.'},
        {name: 'Divulgação Multicanal', description: 'Compartilhe vagas em plataformas de emprego de forma integrada.'},
        {name: 'Página de carreiras', description: 'Criação de um site personalizado para exibir vagas da empresa.'},
        {name: 'Extensão do Chrome', description: 'Ferramenta para facilitar a captação de talentos na web.'},
        {name: 'Suporte prioritário', description: 'Atendimento especializado e rápido para resolver dúvidas.', feature: 'priority_support'},
        {name: 'Questionários/Testes', description: 'Criação de testes personalizados para avaliação de candidatos.', feature: 'questionnaires'},
        {name: 'Ações automatizadas', description: 'Fluxos de trabalho inteligentes para agilizar processos.', feature: 'automated_triggers'},
        {name: 'Vídeo meet', description: 'Entrevistas ou reuniões diretamente na plataforma.', feature: 'video_meet'},
        {name: 'Relatórios personalizados', description: 'Relatórios detalhados adaptados às necessidades do cliente.', feature: 'custom_reports'},
        {name: 'Score de aderência', description: 'Score de aderência automâtico.', feature: 'matcher'},
        {name: 'Permissões personalizadas', description: 'Controle de acesso conforme funções e hierarquias da equipe.', feature: 'custom_roles'},
        {name: 'Contratos personalizados', description: 'Configuração de contratos ajustados às demandas da empresa.', feature: 'custom_contracts'},
        {name: 'Sucesso do cliente dedicado', description: 'Atendimento exclusivo para auxiliar nas operações.', feature: 'customer_success'},
        {name: 'Requisições de vaga', description: 'Processos de aprovação organizados e customizáveis.', feature: 'requisitions'},
        {name: 'Campos customizáveis', description: 'Personalização de campos para atender às necessidades específicas.', feature: 'custom_fields'},
        {name: 'Importação, Exportação', description: 'Importação e Exportação de dados.', feature: 'import_export'}
      ]
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store.dispatch('getBillingPlans').then(res => {
        this.planscopes = res
        this.creating = this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-deck {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: -10px;
  min-width: calc(100% + 20px);
}
  .card-deck > * {
    flex: 1 100%;
    margin: 10px;
    max-width: calc(20% - 20px);
  }
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingPlans.vue